import { useTranslation } from 'react-i18next';

import './Suspence.scss';
import logo from '../asset/image/logo.png';
import { isSupportWasm } from '@utils/browser';

const Room = () => {
  const { t } = useTranslation();

  const isWxUser = /MicroMessenger/i.test(navigator.userAgent);

  return (
    <div className="suspence">
      <div className="suspence__container">
        <img src={logo} srcSet={`${logo} 1x, ${logo} 2x`} className="suspence__container__logo" alt="logo" />
        <div className="suspence__container__title">{t('警告')}</div>
        <div className="suspence__container__content">
          {isWxUser || !isSupportWasm()
            ? t('请在Mac或Win设备使用Chrome浏览器入会')
            : t('暂不支持手机浏览器通过web入会，请在Mac或Win设备使用Chrome浏览器入会')}
        </div>
      </div>
    </div>
  );
};

export default Room;
